import { makeStyles, tokens } from "@fluentui/react-components";
import { flexParent } from "@ms/planner-generic-controls/lib/local/utilities/Mixin.styles";
export const useUpsellStatusModalStyles = makeStyles({
    dialogSurface: {
        minWidth: "850px",
        height: "650px",
        borderRadius: tokens.borderRadiusXLarge
    },
    titleSection: {
        display: "flex",
        marginTop: "-17px",
        alignItems: "flex-start",
        justifyContent: "space-between",
        position: "relative"
    },
    avatar: {
        marginLeft: tokens.spacingVerticalL,
        marginBottom: "5px"
    },
    titleWrapper: {
        marginLeft: "78px",
        marginTop: "-96px",
        position: "relative",
        paddingTop: "32px"
    },
    trialDays: {
        marginTop: "15px",
        marginBottom: "3px",
        fontSize: tokens.fontSizeBase400,
        fontWeight: tokens.fontWeightSemibold,
        color: tokens.colorNeutralForeground1
    },
    trialName: {
        fontSize: tokens.fontSizeBase300,
        fontWeight: tokens.fontWeightRegular,
        color: tokens.colorNeutralForeground3
    },
    contentWrapper: {
        marginLeft: "11px",
        marginRight: "11px",
        minWidth: "750px",
        marginTop: "70px"
    },
    dialogTitle: {
        fontWeight: tokens.fontWeightSemibold,
        fontSize: tokens.fontSizeHero700,
        textAlign: "center",
        lineHeight: tokens.lineHeightBase500,
        color: tokens.colorNeutralForeground1
    },
    dialogContent: {
        marginBottom: "26px",
        marginTop: "17px",
        maxWidth: "676px",
        fontSize: tokens.fontSizeBase400,
        textAlign: "center",
        lineHeight: tokens.lineHeightBase400,
        paddingLeft: "50px",
        color: tokens.colorNeutralForeground1
    },
    imagesWrapper: {
        ...flexParent(),
        justifyContent: "space-evenly"
    },
    image: {
        position: "relative",
        width: "250px",
        height: "185px",
        borderRadius: tokens.borderRadiusLarge,
        margin: `${tokens.spacingVerticalXL} ${tokens.spacingHorizontalXS}`
    },
    footerWrapper: {
        display: "flex",
        justifyContent: "flex-end",
        paddingTop: "40px",
        marginTop: "44px",
        paddingRight: tokens.spacingHorizontalL
    },
    button: {
        borderRadius: tokens.borderRadiusXLarge
    },
    header: {
        display: "flex",
        justifyContent: "flex-end"
    },
    dialogBody: {
        gap: "0px"
    }
});
